/**
 * Application page configuration
 * @constant PAGES
 * @type {object}
 * High-level configuration for the 'pages' (routes) of the application
 * that can be consulted by various components within the app (router, validators, http).
 * By storing this configuration in a config file we avoid hard-coded values in our containers
 * etc. and can therefore abstract generic util methods and change application behaviour more easily
 */
export const PAGES = {
	EmailPage: {
		name: 'EmailPage',
		route: 'email',
	},
	RegisterPage: {
		name: 'RegisterPage',
		route: 'register',
	},
	PasswordPage: {
		name: 'PasswordPage',
		route: 'password',
	},
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/config/pages.js